module.exports = __webpack_public_path__ + "media/ppc/chicago-tribune-59b255d3.png";